"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.multisignStellarMockAddress = exports.notCreatedStellarMockAddress = void 0;
var bignumber_js_1 = require("bignumber.js");
var errors_1 = require("@ledgerhq/errors");
var transaction_1 = __importDefault(require("./transaction"));
var errors_2 = require("../../errors");
var mock_1 = require("./bridge/mock");
exports.notCreatedStellarMockAddress = "GAW46JE3SHIAYLNNNQCAZFQ437WB5ZH7LDRDWR5LVDWHCTHCKYB6RCCH";
exports.multisignStellarMockAddress = "GCDDN6T2LJN3T7SPWJQV6BCCL5KNY5GBN7X4CMSZLDEXDHXAH32TOAHS";
(0, mock_1.addNotCreatedStellarMockAddresses)(exports.notCreatedStellarMockAddress);
(0, mock_1.addMultisignStellarMockAddresses)(exports.multisignStellarMockAddress);
var dataset = {
    implementations: ["js"],
    currencies: {
        stellar: {
            scanAccounts: [
                {
                    name: "stellar seed 1",
                    apdus: "\n            => e002000017038000002c8000009480000000766961206c756d696e61\n            <= 27c586f8499294c64d57f8d7956eef4431de58ab20e1c88001f6cf131c97d6f39000\n            => e002000017038000002c8000009480000001766961206c756d696e61\n            <= 1174242cc3e722e843ac37db3a745897941396d486456e303001b06b417db1f89000\n            => e002000017038000002c8000009480000002766961206c756d696e61\n            <= 8636fa7a5a5bb9fe4fb2615f04425f54dc74c16fefc1325958c9719ee03ef5379000\n            => e002000017038000002c8000009480000003766961206c756d696e61\n            <= 0f052ff4b74726a6f668380927c3d23e9c16d538cb6c272add871e069336bead9000\n            => e002000017038000002c8000009480000004766961206c756d696e61\n            <= 60c75356c268ff0158eeca556526830761327693a93cf4754020fadbe04d0f2b9000\n            => e002000017038000002c8000009480000005766961206c756d696e61\n            <= 124516f8ffb161c9492486e54b4432a2c11e4817414dea54fb8bde13b5ac49439000\n          "
                },
            ],
            accounts: [
                {
                    FIXME_tests: ["balance is sum of ops"],
                    raw: {
                        id: "libcore:1:stellar:GAT4LBXYJGJJJRSNK74NPFLO55CDDXSYVMQODSEAAH3M6EY4S7LPH5GV:sep5",
                        seedIdentifier: "3544cee0d67187d277cd9c7e26a2bf70425b1bee8e92003f45d150c5513d531a",
                        name: "Stellar 1",
                        xpub: "GAT4LBXYJGJJJRSNK74NPFLO55CDDXSYVMQODSEAAH3M6EY4S7LPH5GV",
                        derivationMode: "sep5",
                        index: 0,
                        freshAddress: "GAT4LBXYJGJJJRSNK74NPFLO55CDDXSYVMQODSEAAH3M6EY4S7LPH5GV",
                        freshAddressPath: "44'/148'/0'",
                        freshAddresses: [
                            {
                                address: "GAT4LBXYJGJJJRSNK74NPFLO55CDDXSYVMQODSEAAH3M6EY4S7LPH5GV",
                                derivationPath: "44'/148'/0'"
                            },
                        ],
                        // @ts-expect-error wat
                        unit: {
                            name: "Lumen",
                            code: "XLM",
                            magnitude: 7
                        },
                        blockHeight: 28884793,
                        operations: [],
                        pendingOperations: [],
                        currencyId: "stellar",
                        unitMagnitude: 7,
                        lastSyncDate: "",
                        balance: "371210662",
                        spendableBalance: "371210662"
                    },
                    transactions: [
                        {
                            name: "Same as Recipient",
                            transaction: function (t) { return (__assign(__assign({}, t), { amount: new bignumber_js_1.BigNumber(100), recipient: "GAT4LBXYJGJJJRSNK74NPFLO55CDDXSYVMQODSEAAH3M6EY4S7LPH5GV" })); },
                            expectedStatus: {
                                errors: {
                                    recipient: new errors_1.InvalidAddressBecauseDestinationIsAlsoSource()
                                },
                                warnings: {}
                            }
                        },
                        {
                            name: "Send To New Account - amount is too low",
                            transaction: transaction_1["default"].fromTransactionRaw({
                                amount: "1000",
                                recipient: exports.notCreatedStellarMockAddress,
                                // Have to use an address from the test seed, here is from one coin int testing device
                                useAllAmount: false,
                                family: "stellar",
                                baseReserve: "1500000",
                                networkInfo: {
                                    family: "stellar",
                                    fees: "100",
                                    baseReserve: "1500000"
                                },
                                fees: "100",
                                memoType: null,
                                memoValue: null
                            }),
                            expectedStatus: {
                                errors: {
                                    amount: new errors_1.NotEnoughBalanceBecauseDestinationNotCreated()
                                },
                                warnings: {}
                            }
                        },
                        {
                            name: "send amount more than fees + base reserve",
                            transaction: function (t, account) { return (__assign(__assign({}, t), { amount: account.balance, recipient: "GAIXIJBMYPTSF2CDVQ35WOTULCLZIE4W2SDEK3RQGAA3A22BPWY7R53Z" })); },
                            expectedStatus: {
                                errors: {
                                    amount: new errors_1.NotEnoughSpendableBalance()
                                },
                                warnings: {}
                            }
                        },
                        {
                            name: "send more than base reserve",
                            transaction: function (t, account) { return (__assign(__assign({}, t), { amount: account.balance.minus("100"), recipient: "GAIXIJBMYPTSF2CDVQ35WOTULCLZIE4W2SDEK3RQGAA3A22BPWY7R53Z" })); },
                            expectedStatus: {
                                errors: {
                                    amount: new errors_1.NotEnoughSpendableBalance()
                                },
                                warnings: {}
                            }
                        },
                        {
                            name: "send max to new account (explicit)",
                            transaction: transaction_1["default"].fromTransactionRaw({
                                amount: "0",
                                recipient: "GAIXIJBMYPTSF2CDVQ35WOTULCLZIE4W2SDEK3RQGAA3A22BPWY7R53Z",
                                useAllAmount: true,
                                family: "stellar",
                                baseReserve: "1500000",
                                networkInfo: {
                                    family: "stellar",
                                    fees: "100",
                                    baseReserve: "1500000"
                                },
                                fees: "100",
                                memoType: null,
                                memoValue: null
                            }),
                            expectedStatus: function (account) { return ({
                                errors: {},
                                warnings: {},
                                estimatedFees: new bignumber_js_1.BigNumber("100"),
                                amount: account.balance.minus("1500000").minus("100"),
                                totalSpent: account.balance.minus("1500000")
                            }); }
                        },
                        {
                            name: "memo text - success",
                            transaction: function (t) { return (__assign(__assign({}, t), { amount: new bignumber_js_1.BigNumber(100), recipient: "GAIXIJBMYPTSF2CDVQ35WOTULCLZIE4W2SDEK3RQGAA3A22BPWY7R53Z", memoType: "MEMO_TEXT", memoValue: "01234" })); },
                            expectedStatus: {
                                errors: {},
                                warnings: {}
                            }
                        },
                        {
                            name: "memo text - error",
                            transaction: function (t) { return (__assign(__assign({}, t), { amount: new bignumber_js_1.BigNumber(100), recipient: "GAIXIJBMYPTSF2CDVQ35WOTULCLZIE4W2SDEK3RQGAA3A22BPWY7R53Z", memoType: "MEMO_TEXT", memoValue: "0123456789012345678901234567890123456789" })); },
                            expectedStatus: {
                                errors: {
                                    transaction: new errors_2.StellarWrongMemoFormat()
                                },
                                warnings: {}
                            }
                        },
                        {
                            name: "memo id - success",
                            transaction: function (t) { return (__assign(__assign({}, t), { amount: new bignumber_js_1.BigNumber(100), recipient: "GAIXIJBMYPTSF2CDVQ35WOTULCLZIE4W2SDEK3RQGAA3A22BPWY7R53Z", memoType: "MEMO_ID", memoValue: "22" })); },
                            expectedStatus: {
                                errors: {},
                                warnings: {}
                            }
                        },
                        {
                            name: "memo id - error",
                            transaction: function (t) { return (__assign(__assign({}, t), { amount: new bignumber_js_1.BigNumber(100), recipient: "GAIXIJBMYPTSF2CDVQ35WOTULCLZIE4W2SDEK3RQGAA3A22BPWY7R53Z", memoType: "MEMO_ID", memoValue: "btest2" })); },
                            expectedStatus: {
                                errors: {
                                    transaction: new errors_2.StellarWrongMemoFormat()
                                },
                                warnings: {}
                            }
                        },
                        {
                            name: "memo hash - error",
                            transaction: function (t) { return (__assign(__assign({}, t), { amount: new bignumber_js_1.BigNumber(100), recipient: "GAIXIJBMYPTSF2CDVQ35WOTULCLZIE4W2SDEK3RQGAA3A22BPWY7R53Z", memoType: "MEMO_HASH", memoValue: "dsadsdasdsasseeee" })); },
                            expectedStatus: {
                                errors: {
                                    transaction: new errors_2.StellarWrongMemoFormat()
                                },
                                warnings: {}
                            }
                        },
                    ]
                },
                {
                    FIXME_tests: [
                        "balance is sum of ops",
                        // SourceHasMultiSign will be launch first
                        "Default empty recipient have a recipientError",
                        "invalid recipient have a recipientError",
                    ],
                    raw: {
                        id: "libcore:2:stellar:GCDDN6T2LJN3T7SPWJQV6BCCL5KNY5GBN7X4CMSZLDEXDHXAH32TOAHS:sep5",
                        seedIdentifier: "3544cee0d67187d277cd9c7e26a2bf70425b1bee8e92003f45d150c5513d531a",
                        xpub: "GCDDN6T2LJN3T7SPWJQV6BCCL5KNY5GBN7X4CMSZLDEXDHXAH32TOAHS",
                        derivationMode: "sep5",
                        index: 2,
                        freshAddress: "GCDDN6T2LJN3T7SPWJQV6BCCL5KNY5GBN7X4CMSZLDEXDHXAH32TOAHS",
                        freshAddressPath: "44'/148'/2'",
                        freshAddresses: [
                            {
                                address: "GCDDN6T2LJN3T7SPWJQV6BCCL5KNY5GBN7X4CMSZLDEXDHXAH32TOAHS",
                                derivationPath: "44'/148'/2'"
                            },
                        ],
                        name: "Stellar 3",
                        // @ts-expect-error wat
                        unit: {
                            name: "Lumen",
                            code: "XLM",
                            magnitude: 7
                        },
                        blockHeight: 28884848,
                        operations: [],
                        pendingOperations: [],
                        currencyId: "stellar",
                        unitMagnitude: 7,
                        lastSyncDate: "",
                        balance: "59999500",
                        spendableBalance: "59999500"
                    },
                    transactions: [
                        {
                            name: "Multisign - error",
                            transaction: function (t) { return (__assign(__assign({}, t), { amount: new bignumber_js_1.BigNumber(100), recipient: "GAIXIJBMYPTSF2CDVQ35WOTULCLZIE4W2SDEK3RQGAA3A22BPWY7R53Z", memoType: "MEMO_HASH", memoValue: "dsadsdasdsasseeee" })); },
                            expectedStatus: {
                                errors: {
                                    transaction: new errors_2.StellarWrongMemoFormat()
                                },
                                warnings: {}
                            }
                        },
                    ]
                },
                {
                    FIXME_tests: ["balance is sum of ops"],
                    raw: {
                        id: "js:1:stellar:f30b743cb3a8bc8c3ea8fe8455c6a52221cc6cf867f7f1f5861dd52aba1d0b8a:sep5",
                        seedIdentifier: "gre",
                        name: "GRE's Stellar 2",
                        xpub: "f30b743cb3a8bc8c3ea8fe8455c6a52221cc6cf867f7f1f5861dd52aba1d0b8a",
                        derivationMode: "sep5",
                        index: 1,
                        freshAddress: "",
                        freshAddressPath: "44'/148'/1'",
                        freshAddresses: [],
                        balance: "0",
                        blockHeight: 0,
                        currencyId: "stellar",
                        lastSyncDate: "",
                        operations: [],
                        pendingOperations: [],
                        unitMagnitude: 7
                    }
                },
            ]
        }
    }
};
exports["default"] = dataset;
//# sourceMappingURL=test-dataset.js.map